/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import ContactForm from '../../shared/ContactForm/ContactForm';
import dataLayerPush from '../../../utils/data-layer';

const CREATION_COUNTS = {
    'SAS':                   '1 956',
    'SASU':                  '1 956',
    'SARL':                  '1 560',
    'EURL':                  '1 560',
    'EIRL':                  '1 560',
    'Holding':               '1 160',
    'Auto-entrepreneur':     '9 345',
    'Entreprise individuelle':'5 278',
    'Association':           '1 223',
};

function ContactInformations() {
    const { company } = useContext(UserContext);
    const navigate = useNavigate();

    const [creationCount, setCreationCount] = useState('1 223');

    useEffect(() => {
        const count = CREATION_COUNTS[company.form.legal_statuts] || '1 223';
        setCreationCount(count);
    }, [company.form.legal_statuts]);

    function handleSuccess() {
        dataLayerPush({ event: 'Clickbutton', eventLabel: 'Step 4' });
        navigate('/form/dealname');
    }

    const detail = (
        <>
            🌟 {creationCount} {company.form.legal_statuts} ont été créées le mois dernier en France. 🇫🇷
        </>
    );

    return (
        <ContactForm
            title="C'est parti ! Pouvez-vous renseigner ces quelques informations ?"
            backLink="/form/legal-statuts"
            onSuccess={handleSuccess}
            detail={detail}
        />
    );
}

export default ContactInformations;
